import { render, staticRenderFns } from "./FavoriteCompany.vue?vue&type=template&id=6f6b393b&scoped=true"
import script from "./FavoriteCompany.vue?vue&type=script&lang=js"
export * from "./FavoriteCompany.vue?vue&type=script&lang=js"
import style0 from "./FavoriteCompany.vue?vue&type=style&index=0&id=6f6b393b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b393b",
  null
  
)

export default component.exports